import { Box, Flex, IconButton, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import Select from "react-select";
import {
  unpaidReportRequest,
} from "../../../modules/admin-modules/reports/Actions";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import { CSVLink } from "react-csv";
import { getPaymentSubjectRequest } from "../../../modules/admin-modules/videos/Actions";
import { getAllGroupsRequest } from "../../../modules/admin-modules/groups/Actions";
import { deleteStudentRequest } from "../../../modules/admin-modules/students/Actions";
import { MdWarningAmber } from "react-icons/md";

const UnpaiedReport = ({ setAdd, setSelectedData, searchTerm }) => {
  const dispatch = useDispatch();
  const [paymentId, setPaymentId] = useState("");
  const [groupId, setGroupId] = useState("");
  useEffect(() => {
    if (paymentId) dispatch(unpaidReportRequest(groupId,paymentId));
  }, [groupId,paymentId]);

  useEffect(() => {
    dispatch(getPaymentSubjectRequest());
    dispatch(getAllGroupsRequest());
  }, []);
  const paymentSubjects = useSelector((state) => state.videos.paymentSubjects);
  const paymentSubjectsOptions = paymentSubjects?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const groups = useSelector((state) => state.groups.groups);
  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const unpaidReport = useSelector((state) => state.reports.unpaidReport);
  const isLoading = useSelector((state) => state.reports.isLoading);

  const [offset, setPage] = useState(0);

  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };
  const headers = [
    { label: "name", key: "name" },
    { label: "group_name", key: "group_name" },
    { label: "phone", key: "phone" },
    { label: "parent_phone", key: "parent_phone" },
    { label: "last_attendance_date", key: "last_attendance_date" },
  ];
  const Data = unpaidReport?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      name: data?.name,
      group_name: data?.group?.name,
      phone: data?.phone,
      parent_phone: data?.parent_phone,
      last_attendance_date: data?.last_attendance_date,
      delete: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={
            <MdWarningAmber
              color={data?.deleted_at == null ? "red" : "green"}
            />
          }
          onClick={() => dispatch(deleteStudentRequest(data?.id))}
          isLoading={isLoading}
        />
      ),
      
    };
  });
  const columns = [
    {
      Header: "رقم الطالب",
      accessor: "index",
    },
    {
      Header: "اسم الطالب",
      accessor: "name",
    },
    {
      Header: " المجموعة",
      accessor: "group_name",
    },
    {
      Header: " رقم ولي الامر ",
      accessor: "parent_phone",
    },
    {
      Header: " رقم  الطالب",
      accessor: "phone",
    },
    {
      Header: " تاريخ الحضور الاخير",
      accessor: "last_attendance_date",
    },
    {
      Header: " ايقاف الطالب",
      accessor: "delete",
    },
  ];

  return (
    <Layout>
      <div style={{ minHeight: "400px" }}>
        <Flex
          w="100%"
          my="30px"
          justifyContent="space-between"
          alignItems="center"
          position="relative"
          zIndex="10000000"
        >
          <Text fontSize="24px" fontWeight="600" color="main_1">
            تقرير عدم الدفع
          </Text>
          <Flex w="100%" justifyContent="space-between" alignItems="center" gap={2}>
            <Select
              options={groupsOptions}
              isMulti={false}
              onChange={(data) => {
                setGroupId(data?.value);
              }}
              styles={colourStyles}
              placeholder="Select Group"
            />
            <Select
              options={paymentSubjectsOptions}
              isMulti={false}
              onChange={(data) => {
                setPaymentId(data?.value);
              }}
              styles={colourStyles}
              placeholder="Select Payment"
            />
            <Box
              mx="10px"
              border="1px solid gray"
              borderRadius="8px"
              padding="10px"
            >
              <CSVLink
                headers={headers}
                data={Data?.length != 0 ? Data : []}
                filename={"unpaid-report.csv"}
                className="btn btn-primary"
                target="_blank"
              >
                Download
              </CSVLink>
            </Box>
            <LogoutMenu />
          </Flex>
        </Flex>

        <CTable
          selectedData={viewData}
          Columns={columns}
          Data={Data}
          path={"openModel"}
          Actions
          Title={``}
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar={true}
          noFilter={true}
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar={true}
          isLoading={isLoading}
          perPage={size}
          totalPage={Math.ceil(10 / 50)}
        />
      </div>
    </Layout>
  );
};

export default UnpaiedReport;
